import React from 'react';
import T from 'components/T';
import { M } from '@dashboard-experience/mastodon';

import IconPanel from '../IconPanel';
import useVerificationLogin from './useVerificationLogin';

import securityIcon from '../../images/icons/security.svg';

const DifferentAccount = (): JSX.Element => {
  const switchAccount = useVerificationLogin();

  return (
    <IconPanel
      translationKey='components.Verification.DifferentAccount'
      icon={<img src={securityIcon} alt='' width={62} height={62} />}
      noInfo
      detailsCentered
      data-testid='verification-different-account'
    >
      <div className='text-center'>
        <M.Button
          kind='primary'
          type='button'
          onClick={switchAccount}
          data-testid='verification-switch-account-button'
        >
          <T value='components.Verification.DifferentAccount.button' />
        </M.Button>
      </div>
    </IconPanel>
  );
};

export default DifferentAccount;
